import { ourApproach } from '../components/our-approach.js';

ourApproach();